import { createContext } from 'react';

const useReportContext = createContext();
export default useReportContext;
